import { type BackgroundCheckMissingDataType } from "@src/appV2/OpenShifts/ShiftAction/types";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { createBackgroundCheckUrlFromMissingDataTypes } from "../createBackgroundCheckUrlFromMissingDataTypes";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

interface ShiftBottomSheetBackgroundCheckMissingDataCardProps {
  shiftId: string;
  missingDataTypes: BackgroundCheckMissingDataType[];
}

export function ShiftBottomSheetBackgroundCheckMissingDataCard(
  props: ShiftBottomSheetBackgroundCheckMissingDataCardProps
) {
  const { shiftId, missingDataTypes } = props;
  const history = useHistory();

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Background check data needed"
      description="Your background check is expiring soon. Please provide the required information so a new check can be started."
      illustrationType="document-review"
      footer={
        <Button
          fullWidth
          variant="contained"
          size="medium"
          onClick={() => {
            const url = createBackgroundCheckUrlFromMissingDataTypes({
              queryParams: new URLSearchParams(history.location.search),
              shiftId,
              missingBackgroundCheckDataTypes: missingDataTypes,
            });
            history.push(url);
          }}
        >
          Provide information
        </Button>
      }
    />
  );
}
